<div [formGroup]="this.formGroup" [class.invalid]="!this.formGroup.controls[this.fieldKey].valid && this.formGroup.controls[this.fieldKey].touched">
    <p>{{field.label}}:{{this.field.required ? ' *' : ''}}</p>
    <mat-radio-group class=" example-radio-group " [formControlName]="this.fieldKey ">
        <mat-radio-button class="example-radio-button " *ngFor="let choice of field.choices | keyvalue " [value]="choice.key">
            <span *ngIf="choice.value.value">{{choice.value.value}}</span>
            <span *ngIf="!choice.value.value">{{choice.value}}</span>
        </mat-radio-button>
    </mat-radio-group>
</div>